import React, { useEffect, useState } from 'react';
import serverStore from '../../../stores/server.store';
import Header from '../../components/header/Header';
import LoaderComponent from '../../components/Loader.component';
import ServerItemWrapper from './components/ServerItem2';
import metricsStore from '../../../stores/metrics.store';
import uptimeStore from '../../../stores/uptime.store';
import mongoDbStore from '../../../stores/mongodb.store';
import styled from 'styled-components';
import { addToast } from '../../components/toasts/Toast';
import { startPolling } from '../../../servises/polling.service';
import { Redirect } from 'react-router-dom';
import { loadDetailData } from '../../../servises/detail-loading.service';
import MonitorLoadError from './components/MonitorLoadError';

export const MainStyled = styled.main`
  
`;


const ServerItemPage = props => {
    document.title = 'Monitors - SyAgent';
    const { serverId } = props.match.params;

    const [loader, setLoader] = useState(true);
    const [loadedServerId, setLoadedServerId] = useState(null);
    const [serverListLoaded, setServerListLoaded] = useState(false);
    const [loadError, setLoadError] = useState(false);
    const [loadSequence, setLoadSequence] = useState(0);

    useEffect(() => {
        let active = true;
        setLoader(true);
        setServerListLoaded(false);
        setLoadError(false);
        serverStore.clearProcesses();
        metricsStore.clearMetrics();
        const getServersData = async () => {
            const secondaryFailed = await loadDetailData(
                serverStore.getServers(true),
                [
                    serverStore.getProcessesList(serverId),
                    metricsStore.getMetrics(serverId),
                    uptimeStore.getUptime(),
                    mongoDbStore.getMongoDb()
                ]
            );
            if (secondaryFailed) {
                addToast('Some monitor data could not be loaded', 'error');
            }
            if (active) {
                setServerListLoaded(true);
            }
        };
        getServersData()
            .catch(error => {
                addToast(error.message || 'Failed to load monitor', 'error');
                if (active) {
                    setLoadError(true);
                }
            })
            .finally(() => {
                if (active) {
                    setLoadedServerId(serverId);
                    setLoader(false);
                }
            });
        return () => {
            active = false;
        };
    }, [serverId, loadSequence]);

    useEffect(() => {
        return startPolling(() => {
            return Promise.all([
                serverStore.getProcessesList(serverId),
                metricsStore.getMetrics(serverId)
            ]);
        }, 60000, error => {
            addToast(error.message || 'Failed to refresh monitor', 'error', 'monitor-refresh');
        });
    }, [serverId]);

    if (loadError) {
        return <MonitorLoadError onRetry={ () => setLoadSequence(value => value + 1) }/>;
    }

    return (
        <MainStyled className='servers'>
            <Header/>
            { (loader || loadedServerId !== serverId) && (
                <LoaderComponent/>
            ) }

            { !loader && loadedServerId === serverId && (
                <>
                    { serverListLoaded && !serverStore.serversListObj[serverId] && (
                        <Redirect to="/404"/>
                    ) }
                    { serverListLoaded && serverStore.serversListObj[serverId] && (
                        <ServerItemWrapper serverId={ serverId }/>
                    ) }
                </>
            ) }
        </MainStyled>
    );
};

export default ServerItemPage;
